import { Card, CardProps } from 'components/Card';
import React from 'react';
import {
  TextAreaField,
  TextAreaFieldProps,
} from './TextAreaField/TextAreaField';

type Props<K extends string = string> = TextAreaFieldProps<K> & {
  explanation?: CardProps['explanation'];
  marginBottomHalf?: CardProps['marginBottomHalf'];
};

export const TextAreaFieldWithCharacterCount = <K extends string>({
  explanation,
  marginBottomHalf,
  ...textAreaFieldProps
}: Props<K>): React.ReactElement => {
  const [internalValue, setInternalValue] = React.useState(
    textAreaFieldProps.value || '',
  );

  const characterCount = internalValue.length;
  const characterCountLabel =
    textAreaFieldProps.maxLength !== undefined
      ? `${characterCount}/${textAreaFieldProps.maxLength}`
      : `${characterCount}`;

  return (
    <Card
      label={textAreaFieldProps.label}
      labelRight={characterCountLabel}
      required={textAreaFieldProps.required}
      explanation={explanation}
      marginBottomHalf={marginBottomHalf}
    >
      <TextAreaField {...textAreaFieldProps} _onChange={setInternalValue} />
    </Card>
  );
};
